import { ActionContext, ActionExecutor } from '../baseAction.types'
import { NavigationAction } from './navigationAction.types'

export class NavigationActionExecutor implements ActionExecutor {
  execute(action: NavigationAction, { history }: ActionContext): void {
    history.push(action.data.path)
  }
}
